import { AxiosError } from 'axios'

export function getHttpStatus(error: unknown): number | null {
  if (error instanceof AxiosError) {
    return error.response?.status ?? null
  }
  return null
}

export function isAuthenticationError(error: unknown): boolean {
  const status = getHttpStatus(error)
  return status === 401 || status === 403
}
